import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';
import { useAuth } from '../../providers/AuthContextProvider';

export const LoginError = () => {
    const { error } = useAuth();
    const { oktaAuth, authState } = useOktaAuth();

    useEffect(() => {
        const redirectToOkta = async () => {
            if (!error && !authState?.isAuthenticated) {
                await oktaAuth.signInWithRedirect();
            }
        };

        redirectToOkta();
    }, [error]);

    return <h1 data-testid="error-message">{error}</h1>;
};
